export default "__VITE_PUBLIC_ASSET__8c11877a__"